import {BlockMath, InlineMath} from "react-katex";

const ReinforcedLearningIntro = () => {
    return (
        <div className="max-w-4xl mx-auto px-4">

        <h1 className="tw-header font-bold text-gray-900 mb-4">Reinforcement Learning</h1>
            <p className="text-gray-600 tw-subtitle text-justify">
                Reinforcement learning is a type of machine learning where an AI learns by trying things out and
                seeing what works. Imagine teaching a dog tricks — if it does something right, it gets a treat.
                If not, it gets nothing. Over time, it figures out what actions lead to rewards.
            </p>
            <hr className="mt-2 mb-2"/>
            <p className="tw-subtitle text-gray-600">
                The AI (or agent) explores different actions <InlineMath math="a"/> in a given situation
                (called a state <InlineMath math="s"/>) and learns a strategy — called a policy <InlineMath
                math="\pi(s)"/> —
                to choose the best actions over time.
            </p>
            <BlockMath math="G_t = \sum_{k=0}^{\infty} \gamma^k R_{t+k+1}"/>
            <p className="tw-subtitle text-gray-600">
                This formula calculates the **total future reward** the agent expects to get from a certain point in
                time.
                <br/><br/>
                Here's what it means:
                <ul className="list-disc list-inside mt-2 text-gray-600">
                    <li><b>Gₜ</b> is the total reward starting from time step <b>t</b>.</li>
                    <li><b>Rₜ₊ₖ₊₁</b> is the reward the agent receives at each future step.</li>
                    <li><b>γ</b> (gamma) is a number between 0 and 1 that controls how much the agent cares about future
                        rewards.
                    </li>
                    <li>The <b>Σ</b> symbol (sigma) means we are adding up rewards for every future time step, forever —
                        but discounted over time.
                    </li>
                </ul>
                In short: the agent doesn't just care about the reward it gets now, but also what it can earn in the
                future — just a little less with each step. This encourages it to make smart decisions that pay off in
                the long run.
            </p>

            <p className="tw-subtitle text-gray-600">
                One popular method, called Q-learning, helps the agent figure out the best moves by updating its
                knowledge over time. And that will be explored in depth in a separate section.
            </p>


        </div>
    );
};

export default ReinforcedLearningIntro;
